// Espejo en JS del conversor de backend (cheques/numero_a_letras.py), usado
// solo para la vista previa en vivo mientras el usuario escribe. El valor
// que realmente queda guardado en el historial lo calcula el backend.

const UNIDADES = ['', 'UN', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
const ESPECIALES = ['DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISEIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE'];
const DECENAS = ['', 'DIEZ', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
const VEINTES = ['VEINTE', 'VEINTIUN', 'VEINTIDOS', 'VEINTITRES', 'VEINTICUATRO', 'VEINTICINCO', 'VEINTISEIS', 'VEINTISIETE', 'VEINTIOCHO', 'VEINTINUEVE'];
const CENTENAS = ['', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'];

function convertirGrupo(n) {
  if (n === 0) return '';
  if (n >= 1000000000) {
    const m = Math.floor(n / 1000000000);
    const r = n % 1000000000;
    const prefijo = m === 1 ? 'MIL MILLONES' : `${convertirGrupo(m)} MIL MILLONES`;
    return prefijo + (r > 0 ? ` ${convertirGrupo(r)}` : '');
  }
  if (n >= 1000000) {
    const m = Math.floor(n / 1000000);
    const r = n % 1000000;
    const prefijo = m === 1 ? 'UN MILLON' : `${convertirGrupo(m)} MILLONES`;
    return prefijo + (r > 0 ? ` ${convertirGrupo(r)}` : '');
  }
  if (n >= 1000) {
    const m = Math.floor(n / 1000);
    const r = n % 1000;
    const prefijo = m === 1 ? 'MIL' : `${convertirGrupo(m)} MIL`;
    return prefijo + (r > 0 ? ` ${convertirGrupo(r)}` : '');
  }
  if (n >= 100) {
    if (n === 100) return 'CIEN';
    const c = Math.floor(n / 100);
    const r = n % 100;
    return CENTENAS[c] + (r > 0 ? ` ${convertirGrupo(r)}` : '');
  }
  if (n >= 20) {
    const d = Math.floor(n / 10);
    const r = n % 10;
    if (d === 2) return VEINTES[r];
    return DECENAS[d] + (r > 0 ? ` Y ${UNIDADES[r]}` : '');
  }
  if (n >= 10) return ESPECIALES[n - 10];
  return UNIDADES[n];
}

export function numeroALetras(monto) {
  const valor = Math.max(0, Number(monto) || 0);
  const enteros = Math.floor(valor);
  const centavos = Math.round((valor - enteros) * 100);
  const centavosStr = centavos.toString().padStart(2, '0');

  if (enteros === 0) return `CERO CON ${centavosStr}/100 DÓLARES`;

  return `${convertirGrupo(enteros)} CON ${centavosStr}/100 DÓLARES`.toUpperCase();
}
